export default __webpack_public_path__ + "static/media/Image-Next-Step.8ed11a16.png";